import type { RootState } from '../../index';
import { INLINE_ERROR_CODES } from '../../../constants/errorCodes';

export const selectCurrentError = (state: RootState) => state.error.current;

export const selectInlineError = (state: RootState) => {
  const err = state.error.current;
  if (!err) return null;
  return INLINE_ERROR_CODES.includes(err.code) ? err : null;
};

export const selectToastError = (state: RootState) => {
  const err = state.error.current;
  if (!err) return null;
  return INLINE_ERROR_CODES.includes(err.code) ? null : err;
};
